// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Collapse, Row, Col, Badge } from 'react-bootstrap';
import MemberShipInformationModal from './MemberShipInformationModal';
import { copiriPortalRequest, copiriAxiosPost } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import loader_image from '../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line

const UserMemberShipInformationAccordionItem = ({
	data,
	active,
	onToggle,
	currentIndex,
	pageLanguageContent,
	profileId,
	memebrshipStatus,
	updateData,
	officeRoles
}) => {
	// eslint-disable-next-line
	const { question, showChild, id, member_number, name, role, seal, status_id, is_admin, checked, parent_id, status_text, is_primary } = data;
	const [clicked, setClicked] = useState('0'); // eslint-disable-next-line
	const [showHideModal, setShowHideModal] = useState(false); // eslint-disable-next-line
	const [type, setType] = useState('');
	const [modalHeadingText, setModalHeadingText] = useState('Edit Membership Number'); // eslint-disable-next-line
	const [loader, setLoader] = useState('');
	const handleChildToggle = index => {
		if (clicked === index) {
			return setClicked('0');
		}
		setClicked(index);
	};

	const showHideMemebrShipInforamtionModal = type => {
		if (type === 'memberShipNumber') {
			setModalHeadingText(pageLanguageContent['PRL118'] ? pageLanguageContent['PRL118'] : '');
		}
		if (type === 'memberShipStatus') {
			setModalHeadingText(pageLanguageContent['PRL119'] ? pageLanguageContent['PRL119'] : '');
		}

		if (type === 'memberShipOffice') {
			setModalHeadingText(pageLanguageContent['PRL120'] ? pageLanguageContent['PRL120'] : '');
		}
		if (type === 'history') {
			setModalHeadingText(pageLanguageContent['PRL121'] ? pageLanguageContent['PRL121'] : '');
		}

		setShowHideModal(true);
		setType(type);
	};
	const closeAllModals = () => {
		setShowHideModal(false);
	};

	const handleChangeAdminstrator = (e,id) => {
		const target = e.target;
		var sendFormData = {};
		if (target.value === 'active') {
			sendFormData['is_admin'] = true;
		} else {
			sendFormData['is_admin'] = false;
		}
		copiriPortalRequest('/users/' + profileId + '/memberships/' + data['id'], config.app_version, 'patch', sendFormData)
			.then(response => {
				toast.success('Success');
			})
			.catch(error => {
				toast.error(error?.response?.data?.result);
				document.getElementById('btnradio_yes' + id).checked = false;
				document.getElementById('btnradio_no' + id).checked = true;
			});
	};

	const getStatusText = (status_id) => {
		let statusText = '';
		if (memebrshipStatus && memebrshipStatus.length>0) {
			for (let i=0;i<memebrshipStatus.length;i++) {
				if (memebrshipStatus[i]['id']===status_id) {
					statusText = memebrshipStatus[i]['name']
				}
			}
		}
		return statusText;
	};

	const deleteMemebrship = (e,data, userId) => {
		let formdata = new FormData();
		formdata.append('subj', userId);
		if (data['parent_id'] && data['parent_id'] !=='') {
			formdata.append('action', 'membership_deletion');
			formdata.append('parent_org_id', data['parent_id']);
			formdata.append('child_org_id', data['org_id']);
		} else {
			formdata.append('action', 'memnum');
			formdata.append('obj', data['org_id']);
		}
		var deleteMember = window.confirm(pageLanguageContent['PRL067']);
		if (deleteMember) {
			let parentChild = 'parent';
			let orgId = data['org_id'];
			if (data['parent_id'] && data['parent_id']!=='') {
				parentChild= 'child';
				orgId = data['parent_id']
			}
			setLoader(data['id'])
			copiriAxiosPost(`${config.portal_url}`, formdata)
				.then(response => {
					setLoader('');
					if (response.data.status && response.data.status==='FAIL') {
						toast.error(response?.data?.result)
					} else if (response.data.status && response.data.status==='SUCCESS') {
						toast.success(response?.data?.status)
						updateData(profileId, '', '', 'membership', data['id'], '', orgId, 'memberShipNumber', parentChild);
					} else {

					}
			}).catch(error => {
				setLoader('');
				toast.error(error?.response?.data?.result)
			});
		}
	}

	return (
		<>
			<Card className={'shadow-none border rounded-0 ' + (parent_id ? 'orgChildMember' : '')}>
				<CardHeader					
					className={`py-2 px-lg-3 px-0 border-none cursor-pointer ${
						active ? 'activeMemebrShipHeader' : 'deActiveMemebrShipHeader'
					}`}
				>
					<div onClick={onToggle}>
						<span className='font-weight-medium text-dark text-sans-serif pl-2' > {!is_primary && parent_id && <i className='fas fa-star text-warning'></i> }    {name}</span>
						<div className='openHideAccordian mr-3'>
							<span className={checked ? 'headerText' : ''} onClick={onToggle}>
								{checked ? (
									<>
										{' '}
										{pageLanguageContent['PRL122'] ? pageLanguageContent['PRL122'] : ''}: {checked}{' '}
									</>
								) : (
									''
								)}
							</span>											
							<span className='updownArrow' onClick={onToggle}>
								{active ? <i className='far fa-angle-up'></i> : <i className='far fa-angle-down'></i>}
							</span>						
						</div>
					</div>
					{
						parent_id &&
						<Badge bg={''} className='mr-1' role="button" onClick={e => deleteMemebrship(e, data, profileId)} style={{position:'absolute',right:0,marginTop:'-22px'}}>
							<i className="far fa-trash-alt" ></i>
						</Badge>
					}
				</CardHeader>
				<Collapse in={active}>
					<CardBody className='pt-3'>
						<div className='profile-card-membership'>
							<Row>
								<Col lg={6} className='pc-ms-border-right'>
									<ul>
										<li className='d-flex mb-2'>
											<h4>
												{pageLanguageContent['PRL123'] ? pageLanguageContent['PRL123'] : ''}: <span>{member_number}</span>
											</h4>											
											<div className='ml-auto'>
												<div className='membership-icon'>
													{
														loader && loader===data['id'] && 
														<img
															src={loader_image}
															alt={''}
															height='25'
															width='25'
														/>
													}	
													<Badge
														bg={''}
														className='mr-1 badge badge-soft-info'
														onClick={() => showHideMemebrShipInforamtionModal('memberShipNumber')}
														data-toggle='tooltip'
														title={pageLanguageContent['PRL175'] ? pageLanguageContent['PRL175'] : ''}
													>
														<i className='far fa-edit'></i>
													</Badge>
													{
														member_number && 
														<Badge bg={''} className='mr-1 badge badge-soft-info' role="button" onClick={e => deleteMemebrship(e, data, profileId)}>
															<i className="far fa-trash-alt" ></i>
														</Badge>
													}										
												</div>
											</div>
										</li>
										<li className='d-flex'>
											<h4>
												{pageLanguageContent['PRL124'] ? pageLanguageContent['PRL124'] : ''}:{' '}
												<span>{role}</span>
											</h4>
											<div className='ml-auto'>
												<div className='membership-icon'>
													<Badge
														bg={''}
														className='mr-1 badge badge-soft-info'
														onClick={() => showHideMemebrShipInforamtionModal('memberShipOffice')}
														data-toggle='tooltip'
														title={pageLanguageContent['PRL175'] ? pageLanguageContent['PRL175'] : ''}
													>
														<i className='far fa-edit'></i>
													</Badge>
													<Badge bg={''} className='mr-1 badge badge-soft-info' data-toggle='tooltip' title='View'>
														<i className='fas fa-eye' onClick={() => showHideMemebrShipInforamtionModal('history')}></i>
													</Badge>
												</div>
											</div>
										</li>
									</ul>
								</Col>
								<Col lg={6}>
									<ul className='right-side'>
										<li className='d-flex mb-2'>
											<h4>
												{pageLanguageContent['PRL125'] ? pageLanguageContent['PRL125'] : ''}:{' '}
												<span>{getStatusText(data?.status_id)}</span>
											</h4>
											<div className='ml-auto'>
												<div className='membership-icon'>
													<Badge
														bg={''}
														className='badge badge-soft-info'
														onClick={() => showHideMemebrShipInforamtionModal('memberShipStatus')}
														data-toggle='tooltip'
														title={pageLanguageContent['PRL175'] ? pageLanguageContent['PRL175'] : ''}
													>
														<i className='far fa-edit'></i>
													</Badge>
												</div>
											</div>
										</li>
										<li className='d-flex'>
											<h4>{pageLanguageContent['PRL126'] ? pageLanguageContent['PRL126'] : ''} ?</h4>
											<div className='memebrShipDiv'>
												<span className='mr-2 ml-3'>
													<input
														type='radio'
														id={'btnradio_yes' + id}
														name={'btnradio-' + id}
														className='mr-1 memebrAdmin'
														defaultChecked={is_admin ? true : false}
														value='active'
														onChange={e => handleChangeAdminstrator(e, id)}
													/>
													<label htmlFor='radio1'>
														{pageLanguageContent['PRL038'] ? pageLanguageContent['PRL038'] : ''}
													</label>
												</span>
												<span className='mr-2'>
													<input
														type='radio'
														id={'btnradio_no' + id}
														name={'btnradio-' + id}
														className='mr-1 memebrAdmin'
														defaultChecked={!is_admin ? true : false}
														value='in_active'
														onChange={e => handleChangeAdminstrator(e, id)}
													/>
													<label htmlFor='radio2'>
														{pageLanguageContent['PRL039'] ? pageLanguageContent['PRL039'] : ''}
													</label>
												</span>
											</div>
										</li>
									</ul>
								</Col>
							</Row>
						</div>
					</CardBody>
				</Collapse>
				<MemberShipInformationModal
					showHide={showHideModal}
					onClick={closeAllModals}
					type={type}
					modalHeadingText={modalHeadingText}
					pageLanguageContent={pageLanguageContent}
					membershipData={data}
					profileId={profileId}
					memebrshipStatus={memebrshipStatus}
					updateData={updateData}
					officeRoles={officeRoles}
				/>
			</Card>
		</>
	);
};

export default UserMemberShipInformationAccordionItem;
